/**
 * The Sentry release for this bundle: the deployed commit SHA (Workers Builds'
 * WORKERS_CI_COMMIT_SHA, folded into the `__COMMIT_SHA__` define by
 * vite.config.mts for both the browser bundle and the app Worker). A local
 * build has no SHA and reports `'unknown'`; that is not a release, so it maps
 * to `undefined` and Sentry leaves the field empty.
 */
export function sentryRelease(commitSha: unknown): string | undefined {
  if (typeof commitSha !== 'string') return undefined
  const trimmed = commitSha.trim()
  if (!trimmed || trimmed === 'unknown') return undefined
  return trimmed
}
